import { constructServiceEndpoint } from "./serviceEndpoint";


export const ATTUNE_NODE_SERVICE_LOANAPP_ID = 'loanapp-id';
export const ATTUNE_NODE_SERVICE_ACCOUNT_ID = 'requester-account-id';
export const ATTUNE_NODE_SERVICE_NAME_SPACE = 'namespace';
export const ATTUNE_NODE_SERVICE_ENTITY_ID = 'entity-id';

export const NODE_SERVICE_ENDPOINT = constructServiceEndpoint();
